module.exports = __webpack_public_path__ + "img/58.91f77123.png";